import { Button, Input, List } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { standardQuestionAttestationCategories, standardQuestionIncomeCategories, standardQuestionInsuranceCategories, standardQuestionMedicalCategories, standardQuestionPatientCategories, standardQuestionProviderCategories } from '../../../src/Constants/DataModelToolConstants';
import { standardQuestionSliceDispatch } from "../../Constants/ReduxConstants";
import DeleteConfirmationModal from './DeleteConfirmationModal';
import StandardQuestionModal from "./StandardQuestionModal";

const StandardQuestionViewer = () => {
    const dispatch = useDispatch();
    const questions = useSelector((state: any) => state.standardQuestionViewer.questions);
    const searchValue = useSelector((state: any) => state.standardQuestionViewer.searchValue);
    const searchResults = questions.filter(q => q.label?.toLowerCase()?.includes(searchValue) || q.dataField?.toLowerCase()?.includes(searchValue));
    const modalOpen = useSelector((state: any) => state.standardQuestionViewer.modalOpen);
    const deleteModalOpen = useSelector((state: any) => state.standardQuestionViewer.deleteModalOpen);

    const HandleDelete = async (event) => {
        const selectedQuestion = searchResults.find(q => q.dataField === event.currentTarget.id);
        dispatch({ type: standardQuestionSliceDispatch.setSelectedQuestion, payload: selectedQuestion });
        dispatch({ type: standardQuestionSliceDispatch.setDeleteModalOpen, payload: true });
    }

    const search = (event) => {
        let searchValue = event.target.value.toLowerCase();
        dispatch({ type: standardQuestionSliceDispatch.setSearchValue, payload: searchValue });
    }

    return (
        <div>
            <Input style={{ width: '149px' }} id="questionSearchResults" placeholder='Search...' onChange={search} />
            <br />
            <br />
            <Button
                onClick={() => {
                    dispatch({ type: standardQuestionSliceDispatch.setIsAdd, payload: true });
                    dispatch({ type: standardQuestionSliceDispatch.setModalOpen, payload: true });
                }}>
                Add New Standard Question
            </Button>
            {modalOpen && <StandardQuestionModal />}
            {deleteModalOpen && <DeleteConfirmationModal />}
            <List
                dataSource={searchResults}
                renderItem={(currentQuestion: any, index: number) => (
                    <div key={"question_" + index}>
                        <List.Item key={currentQuestion.dataField}>
                            <List.Item>
                                <Button onClick={() => {
                                    dispatch({ type: standardQuestionSliceDispatch.setSelectedQuestion, payload: currentQuestion });
                                    switch (currentQuestion.tab) {
                                        case 'patient':
                                            dispatch({ type: standardQuestionSliceDispatch.setCategories, payload: standardQuestionPatientCategories });
                                            break;
                                        case 'insurance':
                                            dispatch({ type: standardQuestionSliceDispatch.setCategories, payload: standardQuestionInsuranceCategories });
                                            break;
                                        case 'income & eligibility':
                                            dispatch({ type: standardQuestionSliceDispatch.setCategories, payload: standardQuestionIncomeCategories });
                                            break;
                                        case 'medical':
                                            dispatch({ type: standardQuestionSliceDispatch.setCategories, payload: standardQuestionMedicalCategories });
                                            break;
                                        case 'provider':
                                            dispatch({ type: standardQuestionSliceDispatch.setCategories, payload: standardQuestionProviderCategories });
                                            break;
                                        case 'attestation & signature':
                                            dispatch({ type: standardQuestionSliceDispatch.setCategories, payload: standardQuestionAttestationCategories });
                                            break;
                                        default:
                                            dispatch({ type: standardQuestionSliceDispatch.setCategories, payload: [] });
                                            break;
                                    }
                                    dispatch({ type: standardQuestionSliceDispatch.setIsAdd, payload: false });
                                    dispatch({ type: standardQuestionSliceDispatch.setModalOpen, payload: true });
                                }}>
                                    Edit
                                </Button>
                                <Button key={"question_" + index} id={currentQuestion.dataField} onClick={HandleDelete}>Delete</Button>
                                {currentQuestion.dataField}
                            </List.Item>
                        </List.Item>
                    </div>
                )} />
        </div>
    )
}

export default StandardQuestionViewer;